import {
  getForgetPasswordToken,
  getMyTimeSheetDetails,
  getUserDetailsInfo,
} from "../API";

const generateCrewId = async (foremanUserId, generalForemanUserId) => {
  if (foremanUserId && generalForemanUserId) {
    const foremanData = await getUserDetailsInfo(foremanUserId);
    const generalForemanData = await getUserDetailsInfo(generalForemanUserId);
    return `${foremanData?.data?.employee_id}-${generalForemanData?.data?.employee_id}`;
  } else {
    return `NA`;
  }
};

const getCrewId = (foremanEmployeeId, generalForemanEmployeeId) => {
  if (foremanEmployeeId && generalForemanEmployeeId) {
    return `${foremanEmployeeId}-${generalForemanEmployeeId}`;
  } else {
    return `NA`;
  }
};

const checkToken = async (token) => {
  const isToken = await getForgetPasswordToken(token);
  return isToken?.data;
};

const IsTimeSheetStatusChanged = async (id) => {
  try {
    const res = await getMyTimeSheetDetails(`id=${id}`);
    return res?.data[0]?.time_sheet_status_id > 1;
  } catch (error) {
    console.error("Error fetching timesheet details:", error);
    return false;
  }
};

export { generateCrewId, getCrewId, checkToken, IsTimeSheetStatusChanged };
